import { useNavigate, getRouteApi } from '@tanstack/react-router';
import { Button } from '@workpay/ds-shared/components/ui/Button';
import { useTranslation } from '@hooks/useTranslation';
import { EorAuthLayout } from './EorAuthLayout';
import { StepTitle, StepSub, BackLink } from './components/StepBits';
import AlertCircleIcon from '@assets/icons/AlertCircleIcon';
import form from './EorForm.module.scss';
import styles from './NoWorkspace.module.scss';

const routeApi = getRouteApi('/eor/no-workspace');

export function NoWorkspace() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { email } = routeApi.useSearch();

  const tips = [
    t('K_DS_EXT_EOR_NO_WS_TIP_1', 'Use your work email, not a personal address'),
    t('K_DS_EXT_EOR_NO_WS_TIP_2', 'Double-check for typos in your email address'),
    t('K_DS_EXT_EOR_NO_WS_TIP_3', 'Ask your HR admin if your account has been set up'),
  ];

  return (
    <EorAuthLayout>
      <BackLink label={t('K_DS_EXT_EOR_BACK', 'Back')} onClick={() => navigate({ to: '/eor/find' })} />
      <span className={styles.iconCircle}>
        <AlertCircleIcon className={styles.alert} />
      </span>
      <StepTitle>{t('K_DS_EXT_EOR_NO_WS_TITLE', 'No workspace found')}</StepTitle>
      <StepSub>
        {email
          ? t('K_DS_EXT_EOR_NO_WS_SUB', "We couldn't find a workspace linked to {email}.").replace(
              '{email}',
              email,
            )
          : t('K_DS_EXT_EOR_NO_WS_SUB_GENERIC', "We couldn't find a workspace linked to that email.")}
      </StepSub>

      <div className={styles.tips}>
        <p className={styles.tipsTitle}>{t('K_DS_EXT_EOR_NO_WS_TIPS_TITLE', 'Things to try:')}</p>
        <ul className={styles.tipList}>
          {tips.map((tip, i) => (
            <li key={i}>{tip}</li>
          ))}
        </ul>
      </div>

      <Button variant="primary" size="lg" className={form.cta} onClick={() => navigate({ to: '/eor/find' })}>
        {t('K_DS_EXT_EOR_TRY_DIFF_EMAIL', 'Try a different email')}
      </Button>
    </EorAuthLayout>
  );
}
